/**
 * Method to calculate positions for cta or adcards based on num columns, size of inventory, and number of special cards allowed.
 * - First card will always be the last of the first row
 * - Last card will always be first in the last row
 * @param {number} invLength Length of vehicle inventory
 * @param {number} columns Number of columns per row, also is the num VehicleCards per row
 * @returns {number[]} Array of positions that cards should be placed in with even distribution.
 */
export const getCtaAndAdCardPositions = (invLength, columns, numCards = 3) => {
	const positions = [];
	const completeRows = Math.floor((invLength + numCards) / columns);
	const partialRows = (invLength + numCards) % columns;

	const first = columns - 1;
	positions.push(first);

	const second = Math.round((invLength + numCards) / 2);
	positions.push(second);

	if (columns === 2) {
		const last =
			partialRows > 0
				? completeRows * columns
				: completeRows * columns - 2;
		positions.push(last);
	} else {
		const last =
			partialRows > 0
				? invLength + numCards - partialRows
				: (completeRows - 1) * columns;
		positions.push(last);
	}
	return positions;
};
